import { forwardRef } from "@angular/core"
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms"

export function getValueAccessorProvider(ComponentClass: any): any {
  return {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-forward-ref
    useExisting: forwardRef(() => ComponentClass),
    multi: true,
  }
}

export class ComponentWithNgModel implements ControlValueAccessor {
  protected _value = ""

  public onChange: any = Function.prototype
  public onTouched: any = Function.prototype

  public get value(): any { return this._value }
  public set value(v: any) {
    if (v !== this._value) {
      this._value = v
      this.onChange(v)
    }
  }

  public writeValue(value: any): void { this._value = value }
  public registerOnChange(fn: (value: any) => {}): void { this.onChange = fn }
  public registerOnTouched(fn: () => {}): void { this.onTouched = fn }
}
